import type { IConfigPortalCredentialRepository } from "@src/domain/repositories/config";

export class GetPortalKeysByPurchaserKeyUseCase {
  private readonly repository: IConfigPortalCredentialRepository;

  constructor(repository: IConfigPortalCredentialRepository) {
    this.repository = repository;
  }

  execute(purchaserKey: string) {
    return this.repository.getPortalKeysByPurchaserKey(purchaserKey);
  }
}
